import { render, staticRenderFns } from "./comments-external-scrub-plot-single.vue?vue&type=template&id=1530654a&scoped=true&"
import script from "./comments-external-scrub-plot-single.vue?vue&type=script&lang=js&"
export * from "./comments-external-scrub-plot-single.vue?vue&type=script&lang=js&"
import style0 from "./comments-external-scrub-plot-single.vue?vue&type=style&index=0&id=1530654a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530654a",
  null
  
)

export default component.exports